import { Component, EventEmitter, Inject, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { RecordFactory } from '@common/data-models/records/record-factory';
import { Record } from '@common/data-models/records/record';
import { CollectionRecord } from '@common/data-models/records/collection-record';
import { NavigationService } from "@common/services/navigation-service";
import { EnpsComponent } from '@common/components/base/enps-component';
import { TimeoutQueue } from '@common/services/timeout-queue';

import { NomWebServicesJson } from "@common/services/nom-web-services-json";
import { LanguageSettings } from "@common/services/language-settings";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TopicRecord } from '@src/suite/playbook/data-models/records/topic-record';
import { TopicService } from '@src/suite/playbook/services/topic-service';
import { PlaybookService } from '@src/suite/playbook/services/playbook-service';
import { LayoutState } from '../../services/layout-state';
import { GlobalTablesService } from '../../services/global-tables-service';

@Component({
    selector: 'create-new-template',
    templateUrl: './create-new-template.html',
    styleUrls: ['./create-new-template.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'create-new-template'
    }
})
export class CreateNewTemplate extends EnpsComponent implements OnInit {
    public template: Record;
    public newTitleValue: string = "";
    @Output() public changed = new EventEmitter<string>();


    get isDisabled(): boolean {
        return !this.data.data.title || !this.data.data.title.trim() || this.loading;
    }

    get isSuperVisor(): boolean {
        return this.nomWebServicesJson?.HelloResults?.Supervisor;
    }

    constructor(
        public navigationService: NavigationService,
        timeoutQueue: TimeoutQueue,
        public nomWebServicesJson: NomWebServicesJson,
        public languageSettings: LanguageSettings,
        public topicService: TopicService,
        public dialogRef: MatDialogRef<CreateNewTemplate>,
        public playbookService: PlaybookService,
        public viewStateService: LayoutState,
        public globalTablesService: GlobalTablesService,
        @Inject(MAT_DIALOG_DATA) public data: TopicRecord,
    ) {
        super(timeoutQueue);
    }
    ngOnInit(): void {
        this.getTemplateValue();
        this.newTitleValue = this.title;
    }

    public getTemplateValue(): void {
        if (this.data) {
            this.template = RecordFactory.createTemplateForType(this.data.data.type);
            if (this.data.isCollection) {
                (<CollectionRecord>this.data.data).copyDataAndChildrenTo(<CollectionRecord>this.template);
            } else {
                this.data.data.copyDataTo(this.template);
            }
        }
    }

    public valueChanged(v: string) {
        this.newTitleValue = v;
        this.changed.emit(v);
    }

    get title(): string {
        return this.data.data.title;
    }



    closeDialog() {
        this.dialogRef.close();
    }

    public async createTemplate(event: any, path: string) {
        this.loading = true;
        event = this.newTitleValue;
        this.template.title = event;
        this.navigationService.closeCreateNewTemplate(event);
        this.template.guid = undefined;
        await this.topicService.createTopicContent(this.data.data.database, path, this.data.data?.guid, this.data.data.path.groupId, false, null, null, this.referalId, event);
        await this.playbookService.loadTopicTemplates(this.viewStateService.NavigationViewStateRecord);
        this.closeDialog();
    }

    public async createPersonalTemplate(event: any) {
        const destinationPath = `U_${this.nomWebServicesJson.UserId.toUpperCase()}\\L`;
        await this.createTemplate(event, destinationPath);
    }

    public async createTeamTemplate(event: any) {
        const destinationPath = `P_${this.navigationService.currentPlaybookTeam}\\L`;
        await this.createTemplate(event, destinationPath);
    }

    public async createEnterpriseTemplate(event: any) {
        const destinationPath = `P_${this.globalTablesService.EnterprisePlaybookGroup}\\L`;
        await this.createTemplate(event, destinationPath);
    }
}
